module.exports = __webpack_public_path__ + "static/media/Avatars_Male_New-07.8b302f25.png";